import useIsMobile from 'hooks/use-is-mobile';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setPreviewedSpotId } from 'store/spots/spots-actions';
export const useMapSideEffects = ({ mapWidgetRef, spots }) => {
    const prevPreviewedSpotId = useRef('');
    const isMobile = useIsMobile();
    const { previewedSpotId, mobileMapViewInteractionTrigger } = useSelector((state) => state.spots);
    const dispatch = useDispatch();
    useEffect(() => {
        if (!isMobile)
            return; // This effect is only for mobile
        if (!mapWidgetRef.current)
            return; // Map widget is not initialized yet
        // when user pans the map we trigger a new search.
        // sometimes the previewed spot is removed during the search
        // so, we need to clear the previewed spot id
        if (previewedSpotId && !spots.some(s => s.spotId === previewedSpotId)) {
            dispatch(setPreviewedSpotId({ spotId: '' }));
            // As the previewed spot id has changed, we stop future execution of this effect
            return;
        }
        // handle previewed spot id changes
        if (previewedSpotId &&
            prevPreviewedSpotId.current !== previewedSpotId) {
            // when user has clicked on a spot map pin or has panned the map
            // then scroll the spot list to the previewed spot
            if (mobileMapViewInteractionTrigger === 'click' ||
                mobileMapViewInteractionTrigger === 'pan') {
                const elem = window.document.querySelector(`[data-spot="${previewedSpotId}"]`);
                if (elem) {
                    elem.scrollIntoView({
                        behavior: 'auto',
                        block: 'center',
                        inline: 'center',
                    });
                }
            }
            // when user has scrolled the spot list
            // then pan the map to show the spot card pin
            else if (mobileMapViewInteractionTrigger === 'scroll') {
                mapWidgetRef.current.panTo(previewedSpotId);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        previewedSpotId,
        isMobile,
        mobileMapViewInteractionTrigger,
        spots,
        dispatch,
    ]);
};
